import React, { FC } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { Description } from "@/components/YhBox/Description";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { useDictModel } from "@/views/base/dict/dictModel";
import moment from "moment";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useMaintenanceModel } from "../../chargebackModel";
import { debounce } from "lodash";

interface ITopType {
    id: string,
    mode: "add" | "edit" | "look",
    IYhFormRef: React.MutableRefObject<IYhFormRef | undefined>
}
export const TopButs: FC<ITopType> = ({ id, mode, IYhFormRef }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale,language } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { setSelectedRowKeys,setDescRows,setSelectedRow } = useMaintenanceModel()
    const { detailAddForm, detailEditForm, detailLookForm, insertDetail, resetAddCatch,resetEditCatch, editDetail, getDetailEditOne, Settle, WhConfirm, setDetailAddForm, setDetailItemAddList, setDetailMaterialAddList } = useMaintenanceDetailsModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName,getTreeNodeOne } = useDictModel();

    const save = () => {
        IYhFormRef.current?.validateFields().then(async res => {
            if (mode == "add") {
                const resData = await insertDetail(res)
                if (resData) {
                    // globalPrompt("message", { text: "新增成功", type: "success" });
                    globalPrompt("message", { text: Locale["Successfully added"], type: "success" });
                    goBack();
                    resetAddCatch(mode);
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                }
                // resData == true && goBack() && globalPrompt("message", { text: "新增成功", type: "success" })
            } else if (mode == "edit") {
                let { maintenanceCode, id, status } = detailEditForm
                // if (status == "maintenance.stock-io" || status == "maintenance.settle") {
                //     return message.error(`该维修单${getTreeNodeName(status as string)}，无法在进行编辑操作`)
                // }

                const resData = await editDetail({ ...res, maintenanceCode, id })
                if (resData) {
                    // globalPrompt("message", { text: "编辑成功", type: "success" });
                    globalPrompt("message", { text: Locale["Successfully edited"], type: "success" });

                    goBack();
                    resetEditCatch(mode);
                }
                // resData == true && goBack() && globalPrompt("message", { text: "编辑成功", type: "success" })
            }
        })
    }
    const goBack = () => {
        replaceNav(selectedNavId, "2-5")
    }
    const onRefresh = async () => {
        if (mode == 'add') {
            IYhFormRef.current?.resetFields()
            setDetailAddForm({favorableAmount: 0, discountRate: 100, enterTime: moment(new Date())})
            setDetailItemAddList([])
            setDetailMaterialAddList([])
        } else if (mode == 'edit') {
            getDetailEditOne(id, mode)
        }
        // message.success("刷新成功")
        message.success(Locale["Successfully refreshed"])

    }
    const action = <>
        {mode != "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            // onClick={() => save()}
            onClick={debounce(() => { save() }, 900)}
        >{Locale["Save"]}</Button>}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => goBack()}
        >{Locale["Back"]}</Button>
        {mode !== "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onRefresh}
        >{Locale["Refresh"]}</Button>}
    </>;

    const typeTitle = {
        "add": detailAddForm,
        "edit": detailEditForm,
        "look": detailLookForm,
    }
    const orderStatu: IDescription[] = [
        {
            label: Locale["Chargeback Doc No."],//"维修单号",
            value: typeTitle[mode]?.returnCode as string ?? Locale["Not yet"],
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: Locale["Status"],//"状态",
            // value: (typeTitle[mode]?.status && getTreeNodeName(typeTitle[mode]?.status as string)) ??  Locale["Not yet"],
            value: (typeTitle[mode]?.status && (language == "zh-CN" ? getTreeNodeOne(typeTitle[mode]?.status as string)[0].name : getTreeNodeOne(typeTitle[mode]?.status as string)[0].nameEn as string)) ?? Locale["Not yet"],

            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}